import { render, staticRenderFns } from "./NewAnbieter.vue?vue&type=template&id=4b461f64&scoped=true&"
import script from "./NewAnbieter.vue?vue&type=script&lang=js&"
export * from "./NewAnbieter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b461f64",
  null
  
)

export default component.exports